import "./Pagination.scss";
import arrow from "../../assets/Icon_down_arrow_default.png";
import clsx from "clsx";
import React, {FunctionComponent} from "react";

interface IProps {
    nrOfPages: number;
    activePage: number;
    visible: boolean
}

export const Pagination: FunctionComponent<IProps> = ({activePage, nrOfPages, visible }) => {

    const scrollToPanel = (page: number) => {
        if (page < 1 || page > nrOfPages) {
            return;
        }
        window.scrollTo({
            top: window.innerHeight * (page - 1),
            behavior: "smooth"
        });
    }

    return (<div className={clsx("swipe-panel", {["navigationVisible"]: visible})}>
        <div onClick={() => scrollToPanel(activePage - 1)} className="swiper-arrow">
            <img src={arrow} alt="arrow"/>
        </div>

        {Array(nrOfPages).fill("perryThePlatypus").map((el, index) => (
            <div className={clsx("swiper-circle", {["active"]: activePage === index + 1})}
                 onClick={() => scrollToPanel(index + 1)}>
                <div/>
            </div>))}

        <div onClick={() => scrollToPanel(activePage + 1)} className="swiper-arrow">
            <img src={arrow} alt="arrow"/>
        </div>
    </div>);
}